module.exports = __webpack_public_path__ + "img/empty.d6c4316c.jpg";